module.exports = "<i class=\"js-bubble-delete editor__icons icon-remove fal fa-times\"></i>\n";